import { jsx as s } from "react/jsx-runtime";
import '../../assets/Description.css';const o = "_description_1opbb_1", t = {
  description: o
}, c = ({ copyDescription: i }) => /* @__PURE__ */ s("div", { className: `${t.description} iOSPWA-description`, children: i });
export {
  c as Description
};
